var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('acgn-approve-detail',{attrs:{"comicId":_vm.comicId,"type":2,"userId":_vm.userId,"exportCode":"6005"}})}
var staticRenderFns = []

export { render, staticRenderFns }